import React from 'react';

import {SearchDestinationSummaryInputField} from '../SearchDestinationSummaryInputField';
import {SearchSubmitSummaryButtonField} from '../SearchSubmitSummaryButtonField';

import {useComponent} from './hooks';

import './SearchSummaryFields.less';

import '../SearchSummaryField/SearchSummaryField.less';
import '../SearchSummaryInputField/SearchSummaryInputField.less';
import '../SearchSummaryButtonField/SearchSummaryButtonField.less';

function SearchSummaryFields() {
    const {
        className
    } = useComponent();

    return (
        <div className={className}>
            <SearchDestinationSummaryInputField/>
            <SearchSubmitSummaryButtonField/>
        </div>
    );
}

SearchSummaryFields.whyDidYouRender = true;

export {SearchSummaryFields};
